import React, { useState, useMemo } from 'react';
import { Intl } from '@erecruit/core';
import { AttachmentsPreview } from '@erecruit/modules';
import { Attachment } from '@erecruit/types';
import {
  FlexItem,
  CardInfo,
  A,
  CardInfoItem,
  CardInfoValueType,
  Flex,
  Icon,
  H3,
  styled,
  EmptyState,
} from '@erecruit/ui-kit';

import { DATE_FORMAT } from '../../../../constants';

const { FormattedMessage } = Intl;

const NUMBER_OF_ATTACHMENTS = 3;

const ItemContent = styled('div')({
  '&:hover': {
    cursor: 'pointer',
    opacity: 0.5,
  },
});

const AttachmentsSection = ({ data }: { data: Attachment[] }) => {
  const [isAttachmentVisible, setAttachmentVisibility] = useState<boolean>(
    false,
  );
  const [pickedAttachment, setPickedAttachment] = useState('');

  const attachments = useMemo(() => data.slice(0, NUMBER_OF_ATTACHMENTS), [
    data,
  ]);

  return (
    <FlexItem>
      <CardInfo
        title={
          <H3 align="center">
            <FormattedMessage
              id={messageIds.vms.matchRecord.attachments.title}
            />
            {!!data.length && ` (${data.length})`}
          </H3>
        }
        config={{
          dateFormat: DATE_FORMAT,
        }}
        footer={
          !!attachments.length && (
            <A
              weight={600}
              onClick={() => {
                setAttachmentVisibility(true);
                setPickedAttachment(attachments[0].id);
              }}
            >
              <FormattedMessage
                id={messageIds.vms.matchRecord.attachments.footerText}
              />
            </A>
          )
        }
      >
        {attachments.length ? (
          attachments.map(({ id, name }) => (
            <CardInfoItem
              key={id}
              label="Position description"
              type={CardInfoValueType.Custom}
              value={
                <ItemContent
                  onClick={() => {
                    setAttachmentVisibility(true);
                    setPickedAttachment(id);
                  }}
                >
                  <Flex gutter={2} align="flex-end">
                    <Icon type="reports-2" />
                    <H3 inline>{name}</H3>
                  </Flex>
                </ItemContent>
              }
            />
          ))
        ) : (
          <EmptyState
            description={
              <FormattedMessage
                id={messageIds.vms.matchRecord.attachments.noAttachments}
              />
            }
          />
        )}
      </CardInfo>
      {isAttachmentVisible && (
        <AttachmentsPreview
          isVisible={isAttachmentVisible}
          setVisibility={setAttachmentVisibility}
          attachments={data}
          isLoading={false}
          defaultActive={pickedAttachment}
        />
      )}
    </FlexItem>
  );
};

export default AttachmentsSection;
